export const config = {
    url: process.env['NODE_ENV'] == 'production' ? '' : 'https://ihogroup.ir',
    // url: 'https://features_prd-850.ihogroup.ir/',
    //http://192.168.10.37:1080
    // http://192.168.10.37:82
    // AngularMVC/UserDashboard
}
